export default {"src":"/_next/static/media/circle-certified.415a569e.svg","height":58,"width":59,"blurWidth":0,"blurHeight":0};